import {
  StepProps,
  type StepMap,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import {
  FooterContainer,
  FooterNextButton,
  FooterSkipButton,
  StepTitle,
  StyledStepTitleWrapper,
  WizardContentWrapper,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.styles";
import { DropTargetStep } from "./drop-target-step";
import { StepContentWithTabs } from "@/components/onboarding/components/welcome-wizard/tabs";
import { StepGroups } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.config";
import { MDSIconButton, MDSText, MDSTextVariant, MDSTextWeight, MDSIconKind } from "@/mds";

const OtherAppsStep1: React.FC<StepProps> = ({
  onNavToStep,
  onSkip,
  handleTabSelect,
  onClose,
  context,
}) => (
  <WizardContentWrapper>
    <StyledStepTitleWrapper>
      <StepTitle>Import Notes</StepTitle>
      {context.wizardType === "import" && (
        <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
      )}
    </StyledStepTitleWrapper>
    <StepContentWithTabs
      selectedAppId={context?.selectedAppId || null}
      onAppSelect={handleTabSelect}
      tabConfig={StepGroups["IMPORT"].tabConfig}
    >
      <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
        Bring in your notes so you can find them with Mem Search, Chat, and Heads Up
      </MDSText>
      <DropTargetStep
        onDrop={() => {
          if (context.wizardType === "welcome") onNavToStep?.("download-apps");
          if (context.wizardType === "import") onClose?.();
        }}
      />
    </StepContentWithTabs>
    {context.wizardType === "welcome" && (
      <FooterContainer align="space-between">
        <FooterSkipButton onClick={onSkip}>Skip for now</FooterSkipButton>
        <FooterNextButton onClick={() => onNavToStep?.("download-apps")}>
          Next step
        </FooterNextButton>
      </FooterContainer>
    )}
  </WizardContentWrapper>
);

export const OtherAppsStepsMap: StepMap = {
  "other-apps-1": {
    id: "other-apps-1",
    group: "import-cta",
    render: ({ onNavToStep, onSkip, handleTabSelect, onClose, context }) => (
      <OtherAppsStep1
        onNavToStep={onNavToStep}
        onSkip={onSkip}
        onClose={onClose}
        handleTabSelect={handleTabSelect}
        context={context}
      />
    ),
  },
};
